import request from '../utils/service';

const api = {
    getNearbyParks: function (data) {
        return request({
            url: '/dealer/v2/api/nearbyParks',
            method: 'get',
            params: data
        });
    },
    getNearbyDiffTimeParks: function (data) {
        return request({
            url: '/dealer/v2/api/nearbyDiffTimeParks',
            method: 'get',
            params: data
        });
    },
    getCityList: function () {
        return request({
            url: '/dealer/v2/api/citys',
            method: 'get',
        });
    },
    getConfigs: function () {
        return request({
            url: '/basic/v2/api/paramConfigs',
            method: 'get',
        });
    },
    getNearbyStations: function (data) { // 充电站
      return request({
          url: '/cps/v2/api/nearbyStations',
          method: 'get',
          params: data
      });
    },
    getMapType: function () { // 获取默认地图类型高德、百度
        return request({
            url: '/basic/v2/api/sysCodes/getMapType',
            method: 'get',
            // params: data
        });
      }
};

export default api;
